



































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import StepIdTooltip from '@/components/Steps/StepIdTooltip.vue';
import { Step } from '@/interfaces/Step';
import { Module } from '@/interfaces/Module';
import { StepRequiresStep } from '@/interfaces/StepRequiresStep';
import ModuleStepListStepRequiresTabSelectRequirements from '@/views/ModulePage/ModuleStepListStepRequiresTabSelectRequirements.vue';
import ModuleStepListStepActivatorPickStepRequirements from '@/views/ModulePage/ModuleStepListStepActivatorPickStepRequirements.vue';
import ModuleStepListStepActivator from '@/views/ModulePage/ModuleStepListStepActivator.vue';

@Component({
  components: {
    ModuleStepListStepActivator,
    ModuleStepListStepActivatorPickStepRequirements,
    ModuleStepListStepRequiresTabSelectRequirements,
    StepIdTooltip
  }
})
export default class ModuleStepListStepRequiresTab extends Vue {
  private requiresModal = false;

  private requiredByModal = false;

  private setStepRequires(requires: StepRequiresStep[]) {
    this.$emit('setStepRequires', this.step.id, requires);
  }

  private setStepRequiredBy(required_by: StepRequiresStep[]) {
    this.$emit('setStepRequiredBy', this.step.id, required_by);
  }

  @Prop()
  restrictedUser!: boolean;

  @Prop()
  step!: Step;

  @Prop()
  module!: Module;

  @Prop()
  defaultStep!: Step;
}
